export const generateInsuranceData = () => {
  return []
}
